// src/locales/ta/couriers.js
export const couriers = {
  // Business Couriers
  pageTitle: "வணிக கூரியர்கள்",
  pageDescription: "கூரியர் நிறுவன ஒதுக்கீடுகள் மற்றும் அமைப்புகளை நிர்வகிக்கவும்",
  assignCourier: "கூரியரை ஒதுக்கவும்",
  noCouriersAssigned: "இன்னும் கூரியர் ஒதுக்கப்படவில்லை",
  noCouriersFound: "கூரியர்கள் இல்லை",
  startByAssigning: "உங்கள் வணிகத்துக்கு கூரியர் நிறுவனங்களை ஒதுக்க ஆரம்பிக்கவும்",
  searchCouriers: "கூரியர் தேடவும்...",
  assignFirstCourier: "முதல் கூரியரை ஒதுக்கவும்",
  clearSearch: "தேடலை நீக்கவும்",
  loadingCouriers: "கூரியர்கள் Load ஆகிறது...",
  loadingMessage: "Loading செய்யும் வரை தயவுசெய்து காத்திருக்கவும்",
  unableToLoad: "கூரியர்களை Load செய்ய முடியவில்லை",
  retry: "மீண்டும் முயற்சி செய்யவும்",
  noMatchingCouriers: "உங்கள் தேடலுக்கு பொருந்தும் கூரியர் இல்லை",
  courier: "Courier",
  status: "Status",

  // Stats
  totalAssigned: "மொத்த ஒதுக்கீடு",
  active: "Active",
  apiEnabled: "API Enabled",

  // Badges
  activeStatus: "Active",
  inactiveStatus: "Inactive",
  apiEnabledBadge: "API Enabled",
  webhookEnabledBadge: "Webhook Enabled",

  // Actions
  configure: "Configure",
  remove: "Remove",
  save: "அமைப்பை சேமிக்கவும்",
  cancel: "Cancel",
  close: "Close",
  saving: "Saving...",

  // Assign Modal
  assignModalTitle: "கூரியர் நிறுவனங்களை ஒதுக்கவும்",
  assignModalDescription: "ஒரு அல்லது அதற்கு மேற்பட்ட கூரியர் நிறுவனங்களைத் தேர்ந்தெடுக்கவும்.",
  noCouriersAvailable: "கூரியர் நிறுவனங்கள் இல்லை",
  assign: "Assign",
  assigning: "Assigning...",

  // Configuration Modal
  configureModalTitle: "Configure",
  generalSettings: "பொது அமைப்புகள்",
  activeStatusLabel: "Active Status",
  activeStatusHint: "இந்த கூரியர் ஒதுக்கீட்டை enable/disable செய்யவும்",

  // API Configuration
  apiConfiguration: "API அமைப்பு",
  enableApiIntegration: "API Integration enable செய்யவும்",
  enableApiHint: "Waybill உருவாக்கம் automated ஆகும்",
  apiKey: "API Key",
  apiKeyPlaceholder: "API Key உள்ளிடவும்",
  apiKeyHint: "API Key கூரியர் நிறுவனம் வழங்கும்",
  enableApiUpload: "Orders-ஐ API வழியாக Upload செய்யவும்",
  enableApiUploadHint: "Disable செய்தால், orders கூரியருக்கு தானாக upload ஆகாது; airwaybill number waybill range-இலிருந்து manual ஆக உருவாக்கப்படும். API Integration enable ஆக இருக்கும் வரை tracking (getPackageDetails) தொடர்ந்து செயல்படும்.",
  apiEndpoint: "API Endpoint",
  apiEndpointPlaceholder: "https://api.courier.com/v1",
  apiEndpointHint: "தனிப்பயன் API endpoint URL (optional)",
  additionalApiConfig: "Additional API Config",
  additionalApiConfigPlaceholder: '{"merchantId": "12345", "senderName": "Your Business"}',
  additionalApiConfigHint: "JSON format configuration values",

  // Waybill Configuration
  waybillConfiguration: "Waybill Range Config",
  waybillDescription: "Manual waybill range அமைக்கவும்",
  waybillRangeStart: "Range தொடக்கம்",
  waybillRangeStartPlaceholder: "எ.கா., AWB000001",
  waybillRangeEnd: "Range முடிவு",
  waybillRangeEndPlaceholder: "எ.கா., AWB999999",
  lastWaybillUsed: "கடைசி பயன்படுத்திய Waybill",
  waybillRange: "Waybill Range",
  lastUsed: "நிகழ்ந்த நாள்",

  // Webhook Configuration
  webhookConfiguration: "Webhook அமைப்பு",
  enableWebhook: "Webhook enable செய்யவும்",
  enableWebhookHint: "கூரியர் status updates realtime பெற",
  webhookUrl: "Webhook URL",
  webhookUrlHint: "இந்த URL ஐ கூரியர் நிறுவனத்துக்கு வழங்கவும்",
  regenerateWebhook: "Webhook URL regenerate செய்யவும்",
  regenerating: "Regenerating...",

  // Delete Modal
  confirmRemoval: "Deletion உறுதிப்படுத்தவும்",
  removeConfirmation: "இந்த கூரியரை remove செய்ய வேண்டுமா?",
  removeWarning: "இந்த செயல் தொடர்புடைய அனைத்து அமைப்புகளையும் அகற்றும்.",
  removeCourier: "Remove Courier",
  removing: "Removing...",
  cannotRemove: "Remove can't",
  hasRelatedRecords: "இதற்கு தொடர்புடைய பதிவுகள் உள்ளதால்:",
  removeRelatedRecordsFirst: "முதலில் அந்த பதிவுகளை நீக்க / மாற்றவும்.",
  packingBatches: "packing batch",
  orders: "order",
  assignmentRulesCount: "rule",

  // Account Name
  accountName: "கணக்கு பெயர்",
  accountNamePlaceholder: "எ.கா., முதன்மை கணக்கு",
  accountNameHint: "இந்த கூரியர் கணக்கின் பெயர்",
  accountNameRequired: "கணக்கு பெயர் தேவை",

  // Column Mapping Overrides
  mappings: {
    modalTitle: "Column Mappings",
    modalDescription: "இந்த கூரியர் கணக்குக்கான custom overrides. நிறுவன defaults ஐ விட முன்னுரிமை பெறும்.",
    openMappings: "Column Mappings",
    loadError: "Mapping overrides Load செய்ய முடியவில்லை",
    invoiceType: "Courier Invoice Mapping",
    uploadType: "Upload Format Mapping",
    noOverride: "நிறுவன default mapping பயன்படுத்துகிறது",
    createOverride: "Override உருவாக்கவும்",
    edit: "திருத்தவும்",
    delete: "நீக்கவும்",
    save: "Mapping சேமிக்கவும்",
    mappingName: "Mapping பெயர்",
    mappingNamePlaceholder: "எ.கா., Custom Invoice Format",
    mappingConfig: "Mapping Configuration (JSON)",
    mappingConfigHint: "JSON mappingConfig object",
    notes: "குறிப்புகள்",
    notesPlaceholder: "Optional developer notes...",
    activeStatus: "Active",
    nameRequired: "Mapping பெயர் தேவை",
    invalidJson: "JSON தவறானது",
    configMustBeObject: "Mapping config JSON object ஆக இருக்க வேண்டும்",
    createSuccess: "Mapping override உருவாக்கப்பட்டது",
    updateSuccess: "Mapping override update செய்யப்பட்டது",
    deleteSuccess: "Mapping override நீக்கப்பட்டது",
    saveError: "Mapping override சேமிக்க முடியவில்லை",
    deleteError: "Mapping override நீக்க முடியவில்லை",
    deleteConfirm: "இந்த mapping override நீக்கவா? கூரியர் நிறுவன default க்கு திரும்பும்."
  },

  // Validation Errors
  invalidUrl: "சரியான URL ஐ உள்ளிடவும்",
  invalidJson: "தவறான JSON வடிவமைப்பு",
  rangeError: "End Range, Start Range-ஐ விட குறைவாக இருக்க முடியாது",
  apiKeyRequired: "API Enable செய்யப்பட்டால் API Key தேவை",

  // Success Messages
  assignSuccess: "கூரியர்(கள்) வெற்றிகரமாக ஒதுக்கப்பட்டது",
  createSuccess: "{count} கூரியர் கணக்கு உருவாக்கப்பட்டது",
  updateSuccess: "கூரியர் அமைப்புகள் update செய்யப்பட்டது",
  removeSuccess: "கூரியர் நீக்கப்பட்டது",
  webhookEnabledSuccess: "Webhook Enabled",
  webhookDisabledSuccess: "Webhook Disabled",
  webhookRegeneratedSuccess: "Webhook Regenerated",

  // Error Messages
  assignError: "கூரியரை ஒதுக்க முடியவில்லை",
  updateError: "அமைப்பை update செய்ய முடியவில்லை",
  removeError: "கூரியரை நீக்க முடியவில்லை",
  loadError: "வணிக கூரியர்களை load செய்ய முடியவில்லை",
  loadAvailableError: "கிடைக்கும் கூரியர்கள் load செய்ய முடியவில்லை",
  noChanges: "சேமிக்க மாற்றங்கள் இல்லை",
  selectAtLeastOne: "ஒரு கூரியர் நிறுவனத்தை குறைந்தபட்சம் தேர்ந்தெடுக்கவும்",
  webhookEnableError: "Webhook enable செய்ய முடியவில்லை",
  webhookDisableError: "Webhook disable செய்ய முடியவில்லை",
  webhookRegenerateError: "Webhook regenerate செய்ய முடியவில்லை",

  // Card Details
  addedOn: "சேர்க்கப்பட்டது",
  customEndpoint: "Custom Endpoint",

  // Contact Info
  phone: "தொலைபேசி",
  email: "Email",
  website: "Website",
  address: "முகவரி",

  // Assignment Rules
  assignmentRules: "கூரியர் ஒதுக்கீடு விதிகள்",
  assignmentRulesDescription: "Shop / Geography அடிப்படையில் விதிகளை அமைக்கவும்",
  createRule: "விதி உருவாக்கவும்",
  createFirstRule: "முதல் விதியை உருவாக்கவும்",
  editRule: "விதியைத் திருத்தவும்",
  createRuleTitle: "விதி உருவாக்கவும்",
  noRulesYet: "விதிகள் இல்லை",
  noRulesDescription: "Courier selection automate செய்ய விதிகளை உருவாக்கவும்",
  searchRules: "விதிகளைத் தேடவும்...",
  noRulesFound: "விதிகள் கிடைக்கவில்லை",
  noMatchingRules: "Filters-க்கு பொருந்தும் விதிகள் இல்லை",
  loadingRules: "விதிகள் Load ஆகிறது...",
  loadingRulesMessage: "Loading… தயவுசெய்து காத்திருக்கவும்",
  unableToLoadRules: "விதிகளை Load செய்ய முடியவில்லை",

  // Rule Stats
  totalRules: "மொத்த விதிகள்",
  couriersConfigured: "Configured Couriers",
  defaultRules: "Default Rules",
  defaultFirst: "Default First",
  hasDefault: "Default உள்ளது",

  // Rule Form
  basicInformation: "அடிப்படை தகவல்",
  courierCompany: "கூரியர் நிறுவனம்",
  selectCourierCompany: "கூரியர் நிறுவனத்தைத் தேர்ந்தெடுக்கவும்",
  ruleName: "விதி பெயர்",
  ruleNamePlaceholder: "எ.கா., சென்னை முக்கிய பகுதிகள்",
  priority: "முன்னுரிமை",
  priorityHint: "உயர் எண்ணிக்கை → அதிக முன்னுரிமை",
  description: "விளக்கம்",
  descriptionPlaceholder: "விருப்ப விளக்கம்...",
  ruleConfiguration: "விதி அமைப்பு",
  ruleConfigDescription: "விதிகள் இந்த வரிசையில் மதிப்பிடப்படும்: Shop → City → Zone → District → Province",
  setAsDefault: "Default Rule அமைக்கவும்",
  setAsDefaultHint: "ஒரு கூரியருக்கு ஒரு Default Rule மட்டும் இருக்க முடியும்",
  unsetAsDefault: "Default ஐ நீக்கு",

  // Rule Types
  shopRules: "Shop Rules",
  cityRules: "City Rules",
  shippingZoneRules: "Shipping Zone Rules",
  districtRules: "District Rules",
  provinceRules: "Province Rules",

  // Rule Actions
  addRule: "விதியைச் சேர்க்கவும்",
  noRulesConfigured: "விதிகள் அமைக்கப்படவில்லை",
  include: "Include",
  exclude: "Exclude",
  showDetails: "விவரங்கள்",
  hideDetails: "மறைக்கவும்",
  duplicate: "Duplicate",
  copy: "Copy",

  // Rule Selection
  selectMultipleHint: "Ctrl/Cmd அழுத்தி multi-select செய்யவும்",
  selected: "தேர்ந்தெடுக்கப்பட்டது",
  shop: "Shop",
  city: "City",
  zone: "Zone",
  district: "District",
  province: "Province",

  // Filters
  allCouriers: "அனைத்து கூரியர்கள்",
  allStatus: "அனைத்து Status",
  sortBy: "Sort By",
  sortByCourier: "Courier",
  sortByPriority: "Priority",
  sortByStatus: "Status",
  sortByDate: "Date Created",
  clearFilters: "Filters நீக்கு",

  // Delete Rule
  confirmDeletion: "Deletion உறுதிப்படுத்தவும்",
  deleteRuleConfirmation: "இந்த விதியை நீக்க வேண்டுமா?",
  deleteRuleWarning: "இந்த செயலை மீண்டும் மாற்ற முடியாது.",
  deleteRule: "விதி நீக்கவும்",
  deleting: "Deleting...",

  // Rule Success Messages
  ruleCreatedSuccess: "விதி வெற்றிகரமாக உருவாக்கப்பட்டது",
  ruleUpdatedSuccess: "விதி update செய்யப்பட்டது",
  ruleDeletedSuccess: "விதி நீக்கப்பட்டது",
  ruleActivatedSuccess: "Rule Activated",
  ruleDeactivatedSuccess: "Rule Deactivated",
  defaultSetSuccess: "Default rule அமைக்கப்பட்டது",
  defaultUnsetSuccess: "Default rule அகற்றப்பட்டது",

  // Rule Error Messages
  ruleCreateError: "விதியை உருவாக்க முடியவில்லை",
  ruleUpdateError: "விதியை update செய்ய முடியவில்லை",
  ruleDeleteError: "விதியை நீக்க முடியவில்லை",
  ruleLoadError: "விதி தரவை load செய்ய முடியவில்லை",
  ruleToggleError: "Rule status மாற்ற முடியவில்லை",
  defaultToggleError: "Default status மாற்ற முடியவில்லை",

  // Rule Details
  configuration: "அமைப்பு",
  createdBy: "உருவாக்கியவர்",
  updatedBy: "புதுப்பித்தவர்",
  rules: "rules",
  rule: "rule",
  updateRule: "விதியை update செய்யவும்",
  selectItemsToInclude: "Include செய்ய பொருட்களைத் தேர்ந்தெடுக்கவும்",
  selectItemsToExclude: "Exclude செய்ய பொருட்களைத் தேர்ந்தெடுக்கவும்",
  unknown: "Unknown",
  // Courier delivery charges (rate card)
  deliveryCharges: "Delivery Charges",
  deliveryChargesModalTitle: "Delivery Charges -",
  deliveryChargesModalDesc: "Set what this courier charges you for each shipping zone. Used to check courier invoices.",
  extraChargesDesc: "Courier charge per extra kilogram beyond the base delivery",
  deliveryChargesLoading: "Loading delivery charges...",
  saveDeliveryCharges: "Save Delivery Charges",
  deliveryChargesSaved: "Courier delivery charges saved successfully",
  deliveryChargesSaveFailed: "Failed to save courier delivery charges",
  deliveryChargesLoadFailed: "Failed to load courier delivery charges",
  deliveryChargesTab: "Delivery Charges",
  returnChargesTab: "Return Charges",
  returnChargesModalDesc: "Set what this courier charges you for returned orders in each shipping zone.",
  returnExtraChargesDesc: "Courier return charge per extra kilogram",
  setFreeReturnAll: "Free Returns for All",
  saveCharges: "Save Charges",
  bulkEditReturnCharges: "Bulk Edit Return Charges",
  returnChargeAmount: "Return Charge Amount",
  bulkEditReturnHint: "This amount will be applied to all shipping zones for returns",
  extraChargePerKgLabel: "Extra Charge per Kg",
  bulkEditExtraHint: "Leave empty to keep each zone's current extra charge"
};
